import React from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import { Badge } from 'react-bootstrap';
import { FaRoad, FaClock } from 'react-icons/fa';
import { normalizeModeCompteur } from '../utils/normalize';

const formatNumber = (value) => {
  if (value === null || value === undefined || value === '') return '—';
  const n = Number(value);
  if (!Number.isFinite(n)) return value;
  return n;
};

const formatWithUnit = (value, mode) => {
  const n = formatNumber(value);
  if (n === '—') return n;
  return `${n} ${normalizeModeCompteur(mode) === 'km' ? 'km' : 'h'}`;
};

const TableComponentVidange = ({ rows = [] }) => {

  // ✅ ON UTILISE LES CLASSES CSS
  const rowClasses = (row) => {
    const code = row?.statut?.code || '';

    if (code === 'DEPASSE') return 'vd-row-depasse';
    if (code === 'CRITIQUE') return 'vd-row-critique';
    if (code === 'ALERTE') return 'vd-row-alerte';
    return 'vd-row-ok';
  };

  const columns = [
    {
      dataField: 'id',
      text: 'ID',
      sort: true,
      filter: textFilter({ placeholder: 'ID...' }),
      headerStyle: { width: '80px' }
    },
    {
      dataField: 'matricule',
      text: 'Matricule',
      sort: true,
      filter: textFilter({ placeholder: 'Matricule...' })
    },
    {
      dataField: 'type',
      text: 'Type',
      sort: true,
      filter: textFilter({ placeholder: 'Type...' })
    },
    {
      dataField: 'societe',
      text: 'Société',
      sort: true,
      filter: textFilter({ placeholder: 'Société...' })
    },
    {
      dataField: 'chantier_actuel',
      text: 'Chantier actuel',
      sort: true,
      filter: textFilter({ placeholder: 'Chantier...' }),
      formatter: (cell) => cell || '—'
    },
    {
      dataField: 'mode_compteur',
      text: 'Mode',
      sort: true,
      filter: textFilter({ placeholder: 'h / km...' }),
      formatter: (cell) => {
        const mode = normalizeModeCompteur(cell);

        return mode === 'km' ? (
          <Badge bg="primary">
            <FaRoad className="me-1" />
            KM
          </Badge>
        ) : (
          <Badge bg="info" text="dark">
            <FaClock className="me-1" />
            Heure
          </Badge>
        );
      }
    },
    {
      dataField: 'date_vidange',
      text: 'Dernière vidange',
      sort: true,
      filter: textFilter({ placeholder: 'AAAA-MM-JJ...' }),
      formatter: (cell) => cell || '—'
    },
    {
      dataField: 'cycle_value',
      text: 'Cycle actuel',
      sort: true,
      formatter: (cell, row) => formatWithUnit(cell, row?.mode_compteur)
    },
    {
      dataField: 'interval_value',
      text: 'Intervalle',
      sort: true,
      formatter: (cell, row) => formatWithUnit(cell, row?.mode_compteur)
    },
    {
      dataField: 'reste_value',
      text: 'Reste',
      sort: true,
      formatter: (cell, row) => formatWithUnit(cell, row?.mode_compteur)
    },
    {
      dataField: 'statut.code',
      text: 'Statut',
      sort: true,
      formatter: (_, row) => {
        const code = row?.statut?.code || '';

        if (code === 'DEPASSE') return <Badge bg="dark">Dépassé</Badge>;
        if (code === 'CRITIQUE') return <Badge bg="danger">Critique</Badge>;
        if (code === 'ALERTE') return <Badge bg="warning" text="dark">Alerte</Badge>;
        return <Badge bg="success">OK</Badge>;
      }
    },
    {
      dataField: 'etat',
      text: 'État',
      sort: true,
      filter: textFilter({ placeholder: 'État...' }),
      formatter: (cell) => cell || '—'
    }
  ];

  return (
    <div style={{ minWidth: '1200px' }}>
      <BootstrapTable
        keyField="id"
        data={rows}
        columns={columns}
        pagination={paginationFactory({
          sizePerPage: 20,
          sizePerPageList: [
            { text: '20', value: 20 },
            { text: '50', value: 50 },
            { text: '100', value: 100 }
          ],
          showTotal: true,
          alwaysShowAllBtns: true
        })}
        filter={filterFactory()}
        striped
        condensed
        bordered={false}
        rowClasses={rowClasses} 
        noDataIndication="Aucun matériel à afficher"
        wrapperClasses="table-responsive"
      />
    </div>
  );
};

export default React.memo(TableComponentVidange);